var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApplyActive({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "64px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    id: "\\u9875\\u9762-1",
    stroke: "none",
    strokeLinecap: "round",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u5BFC\\u822A\\u56FE\\u6807",
    stroke: "#03a9f4",
    strokeWidth: 1.5,
    transform: "translate(-103.000000, -334.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7533\\u8BF7",
    transform: "translate(103.000000, 334.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u8DEF\\u5F84",
    transform: "translate(4.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16,14.5 L16,19 C16,19.5523 15.5523,20 15,20 L11.75,20",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,6 L16,1 C16,0.447715 15.5523,0 15,0 L1,0 C0.447715,0 0,0.447715 0,1 L0,19 C0,19.5523 0.447715,20 1,20 L4,20",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    x2: 11,
    y1: 6,
    y2: 6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7.5,
    x2: 16,
    y1: 20,
    y2: 9.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    x2: 8,
    y1: 10,
    y2: 10
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplyActive);
export default __webpack_public_path__ + "static/media/apply_active.8e86accbbc0e61377ea6b91343f8a5df.svg";
export { ForwardRef as ReactComponent };